import ListItemLoading from "@/components/loading/listItemLoading/listItemLoading";
import { useUserFormContext } from "@/pages/dashboard/teams/teamMembers/add/Context";
import { useGetMerchantServices } from "@/services/appointment/hooks/useGetMerchantServices";
import {
  Checkbox,
  Divider,
  Group,
  Pill,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useEffect } from "react";
import { CategoryWithChecked, ServiceWithChecked } from "./type";
import { UseListStateHandlers } from "@mantine/hooks";

type Props = {
  showHeader?: boolean;
  handlers: UseListStateHandlers<CategoryWithChecked>;
  values: CategoryWithChecked[];
};

function TeamMemberService({ showHeader = true, handlers, values }: Props) {
  const { data, isLoading } = useGetMerchantServices();
  const form = useUserFormContext();

  useEffect(() => {
    if (data) {
      handlers.setState(
        data
          ?.filter((x) => x.services?.length && x.services?.length > 0)
          .map((item) => ({
            ...item,
            checked:
              item?.services?.every((service) =>
                form.values.services.some(
                  (selected) => selected.id === service.id
                )
              ) ?? false,
            services: item?.services?.map((service) => ({
              ...service,
              checked: form.values.services.some(
                (selected) => selected.id === service.id
              ),
            })),
          }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, form.values.services]);

  // Update form values when values state changes
  // useEffect(() => {
  //   const selectedServices = values
  //     .flatMap((x) => x?.services || [])
  //     .filter((y) => y.checked);

  //   // Only update if the selected services have actually changed
  //   const currentIds = form.values.services.map((s) => s.id).sort();
  //   const newIds = selectedServices.map((s) => s.id).sort();

  //   if (JSON.stringify(currentIds) !== JSON.stringify(newIds)) {
  //     form.setFieldValue("services", selectedServices);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [values]);

  return (
    <Stack>
      <Stack gap="0">
        {showHeader && (
          <>
            <Title order={5}> خدمات </Title>
            <Text size="sm" pt="xs">
              خدماتی را که این عضو تیم ارائه می‌دهد انتخاب کنید (اختیاری)
            </Text>
          </>
        )}
      </Stack>
      <>
        <Stack mb="20px">
          <Checkbox
            disabled={isLoading}
            mt="xs"
            size="md"
            checked={values.every(
              (item) =>
                item.checked &&
                item?.services?.every(
                  (child: ServiceWithChecked) => child.checked
                )
            )}
            onChange={(event) =>
              handlers.setState(
                values.map((item) => ({
                  ...item,
                  checked: event.currentTarget.checked,
                  services: item?.services?.map(
                    (child: ServiceWithChecked) => ({
                      ...child,
                      checked: event.currentTarget.checked,
                    })
                  ),
                }))
              )
            }
            label={
              <Text size="md" fw={600}>
                انتخاب همه
              </Text>
            }
          />
          <Divider />
        </Stack>
        {isLoading && <ListItemLoading count={3} />}
        {values?.map((item, index) => (
          <Stack mb="40px">
            <Group gap="xs" align="flex-end">
              <Checkbox
                mt="xs"
                size="md"
                label={
                  <Text size="md" fw={600}>
                    {item.title}
                  </Text>
                }
                key={index}
                checked={item.checked}
                onChange={(event) =>
                  handlers.setState(
                    values.map((val, idx) =>
                      idx === index
                        ? {
                            ...val,
                            checked: event.currentTarget.checked,
                            services: val?.services?.map(
                              (child: ServiceWithChecked) => ({
                                ...child,
                                checked: event.currentTarget.checked,
                              })
                            ),
                          }
                        : val
                    )
                  )
                }
              />
              <Pill>{item?.services?.length}</Pill>
            </Group>

            <Divider />

            <Stack>
              {item?.services?.map(
                (child: ServiceWithChecked, childIndex: number) => (
                  <>
                    <Checkbox
                      size="md"
                      my="sm"
                      key={childIndex}
                      checked={child.checked}
                      onChange={(event) => {
                        const newValues = [...values];
                        if (newValues[index]?.services?.[childIndex]) {
                          newValues![index]!.services![childIndex]!.checked =
                            event?.currentTarget?.checked || false;

                          // Check if all children are checked to update parent
                          const allChildrenChecked = newValues[
                            index
                          ]?.services?.every(
                            (child: ServiceWithChecked) => child.checked
                          );
                          newValues[index]!.checked =
                            allChildrenChecked || false;

                          handlers.setState(newValues);
                        }
                      }}
                      label={
                        <Text size="md" fw={600}>
                          {child.title}
                        </Text>
                      }
                    />
                    <Divider mr="40px" />
                  </>
                )
              )}
            </Stack>
          </Stack>
        ))}
      </>
    </Stack>
  );
}

export default TeamMemberService;
